enum osPlatform {
  mac = 'Mac',
}
export default osPlatform;
